/** エラーメッセージコンポーネント。 */
export const ErrorMessage = () => {
  return (
    <p className="text-[16px] noto-sans-jp text-textPrimary">
      エラーが発生しました。もう一度お試しください。
    </p>
  );
};
